import { Box, Modal } from '@mui/material';
import { useState } from 'react';
import { useSystemActions } from 'stores';
import { ModalBoxStyle } from '../ModalBox/styles';

interface ImageBoxProps {
	img: string;
}

const ImageBox = ({ img }: ImageBoxProps) => {
	const [open, setOpen] = useState(false);
	const { getImage } = useSystemActions();

	const getImageURL = () => {
		if (img)
			return `${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${img}`;
		return `${getImage('img_upload.png')}`;
	};
	const handleImagePreview = () => {
		setOpen(true);
	};

	return (
		<>
			<Box
				sx={{
					backgroundColor: 'background.default',
					backgroundImage: `url(${getImageURL()})`,
					backgroundSize: '100% 100%',
					// borderRadius: "8px",
					width: '64px',
					height: '64px',
				}}
				onClick={handleImagePreview}
			/>
			<Modal
				open={open}
				onClose={() => {
					setOpen(false);
				}}
			>
				<Box sx={ModalBoxStyle} component="img" src={getImageURL()} />
			</Modal>
		</>
	);
};

export default ImageBox;
